import styled, {css} from "styled-components/macro";
import {device} from "../../styles";
import {IsActive} from "../../data";

export const Root = styled.div`
    
    ${device.less768} {
        position: absolute;
        bottom: 100%;
        left: 0;
        right: 0;
        
        background-color: var(--color-accent-reversed);
        transition: height 0.5s ease-out;
        box-shadow: 0 -30px 60px 0px rgba(0, 0, 0, 0.05);
        border-top-left-radius: 10px;
        border-top-right-radius: 10px;
        border-top: 1px solid #dedede;
    }
`;

export const Head = styled.div`
    display: none;
    
    ${device.less768} {
        position: relative;
        display: flex;
        width: 100%;
        overflow: hidden;
        justify-content: space-between;
        flex-wrap: wrap;
        align-items: center;
        gap: 10px;
        height: 58px;
        border-bottom: 1px solid #dedede;
    }
`;

export const HeadItem = styled.div`
    ${device.less768} {
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
    }
`;

export const IconWrap = styled.div<IsActive>`
    width: 35px;
    height: 35px;
    display: flex;
    justify-content: center;
    align-items: center;
    border: 1px solid var(--color-border);
    border-radius: 50%;
    cursor: pointer;
    outline: none;
    overflow: hidden;
    position: relative;
    transition: border-color .3s;
    background-color: #fff;
    margin-bottom: 3px;
    
    ${(props) => props.$isActive && css`
        filter: invert(1);
    `}
`;


export const Icon = styled.div`
    width: 33px !important;
    height: 33px !important;
`;

export const Label = styled.div`
    ${device.less768} {
        font-size: 7px;
        line-height: 10px;
        text-transform: uppercase;
        white-space: nowrap;
    }
`;

export const Body = styled.div<{$isOpened?: boolean}>`
    display: flex;
    flex-direction: column;
    gap: 10px;
    
    ${device.less768} {
        overflow-y: auto;
        height: 0;
        padding: 0 15px;
        transition: height 0.4s ease-in-out, padding 0.4s ease-in-out;

        box-shadow: 0 20px 20px -20px rgba(0,0,0,0.10) inset, 0 -20px 20px -20px rgba(0,0,0,0.10) inset;
        
        ${(props) => props.$isOpened && css`
            height: 50vh;
            padding: 15px;
        `}
    }
`;
